import React, { useEffect, useRef, useState, useCallback } from 'react';
import { useAuth } from '../context/AuthContext';
import { operazioniInAttesa } from '../services/offline';

/**
 * Disconnette dopo un periodo di inattività, avvisando prima.
 * Il conteggio si azzera a ogni interazione e si sospende
 * finché ci sono modifiche non ancora inviate al server.
 */
const MINUTI_INATTIVITA = 30;   // durata complessiva
const MINUTI_AVVISO     = 5;    // preavviso prima della disconnessione

export default function TimeoutInattivita() {
  const { logout, user } = useAuth();
  const [avviso, setAvviso]     = useState(false);
  const [secondi, setSecondi]   = useState(MINUTI_AVVISO * 60);
  const ultimaAzione = useRef(Date.now());

  const riprendi = useCallback(() => {
    ultimaAzione.current = Date.now();
    setAvviso(false);
    setSecondi(MINUTI_AVVISO * 60);
  }, []);

  // Ogni interazione rimanda la scadenza
  useEffect(() => {
    if (!user) return;
    const eventi = ['mousedown', 'keydown', 'touchstart', 'scroll', 'wheel'];
    const segna = () => { ultimaAzione.current = Date.now(); };
    eventi.forEach(e => window.addEventListener(e, segna, { passive: true }));
    return () => eventi.forEach(e => window.removeEventListener(e, segna));
  }, [user]);

  // Controllo periodico
  useEffect(() => {
    if (!user) return;

    const timer = setInterval(() => {
      // Con lavoro non ancora inviato la sessione non scade
      if (operazioniInAttesa() > 0) {
        ultimaAzione.current = Date.now();
        if (avviso) riprendi();
        return;
      }

      const fermo = (Date.now() - ultimaAzione.current) / 60000;

      if (fermo >= MINUTI_INATTIVITA) {
        logout();
        return;
      }

      if (fermo >= MINUTI_INATTIVITA - MINUTI_AVVISO) {
        setAvviso(true);
        setSecondi(Math.max(0, Math.round((MINUTI_INATTIVITA - fermo) * 60)));
      } else if (avviso) {
        setAvviso(false);
      }
    }, 5000);

    return () => clearInterval(timer);
  }, [user, avviso, logout, riprendi]);

  if (!user || !avviso) return null;

  const min = Math.floor(secondi / 60);
  const sec = String(secondi % 60).padStart(2, '0');

  return (
    <div style={{
      position:'fixed', inset:0, background:'rgba(0,0,0,.55)', zIndex:3000,
      display:'flex', alignItems:'center', justifyContent:'center', padding:20,
    }}>
      <div style={{
        background:'#fff', borderRadius:14, padding:'28px 32px', maxWidth:400,
        textAlign:'center', boxShadow:'0 10px 40px rgba(0,0,0,.3)',
      }}>
        <div style={{ fontSize:40, marginBottom:10 }}>⏳</div>
        <h3 style={{ margin:'0 0 8px', fontSize:17 }}>Sessione in scadenza</h3>
        <p style={{ margin:'0 0 4px', fontSize:14, color:'#6b7280' }}>
          Sei inattivo da un po'. Per sicurezza verrai disconnesso tra
        </p>
        <div style={{ fontSize:34, fontWeight:800, color:'#b30000', margin:'6px 0 18px' }}>
          {min}:{sec}
        </div>
        <div style={{ display:'flex', gap:8 }}>
          <button className="btn btn-secondary" style={{ flex:1 }} onClick={logout}>
            Esci ora
          </button>
          <button className="btn btn-primary" style={{ flex:1 }} onClick={riprendi}>
            Resta collegato
          </button>
        </div>
      </div>
    </div>
  );
}
